import React, { useState, useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { Box } from '@mui/material';

import Header from './Header';
import { ConfigurationProvider } from '../providers/ConfigurationContext';
import { UserProvider } from '../providers/UserContext';
import { AuthProvider } from '../providers/AuthContext';
import { ApiProvider } from '../providers/ApiContext';
import { PageTitleProvider } from '../providers/PageTitleContext';
import { DocTypesProvider } from '../providers/DocTypesContext';
import MainSidebar from './MainSidebar';

const Layout: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [headerHeight, setHeaderHeight] = useState<number>(0);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const headerElement = document.querySelector('.MuiAppBar-root'); // Adjust selector to match your Header's class (e.g., '.MuiAppBar-root' for AppBar)
      if (headerElement && headerElement instanceof HTMLElement) {
        setHeaderHeight(headerElement.offsetHeight);
      }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    return () => window.removeEventListener('resize', updateHeaderHeight);
  }, []);

  const toggleMainSidebar = () => {
    setOpen(!open);
  };

  return (
    <PageTitleProvider>
      <ConfigurationProvider>
        <AuthProvider>
          <ApiProvider>
            <UserProvider>
              <DocTypesProvider>
                <Header
                  mainSidebarOpen={open}
                  toggleMainSidebar={toggleMainSidebar}
                />
                <MainSidebar open={open} toggleDrawer={toggleMainSidebar} />
                <Box
                  component='main'
                  sx={{
                    flexGrow: 1,
                    // paddingTop: `${headerHeight}px`,
                    height: `calc(100% - ${headerHeight}px)`,
                    overflowY: 'auto',
                    boxSizing: 'border-box',
                    '&::-webkit-scrollbar': { width: '8px' }, // Optional: Style the scrollbar to make it visible/distinct
                  }}
                >
                  <Box
                    sx={{
                      minHeight: '100%',
                      boxSizing: 'border-box',
                      margin: 0,
                      padding: 0,
                    }}
                  >
                    <Outlet />
                  </Box>
                  <ScrollRestoration />
                </Box>
              </DocTypesProvider>
            </UserProvider>
          </ApiProvider>
        </AuthProvider>
      </ConfigurationProvider>
    </PageTitleProvider>
  );
};

export default Layout;
